import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FileUploadFor, KeyValueSetInt, LocalService, PageKey, PageKeyAccessType } from '../../../service/local.service';
import { MenuPagekeyComponent } from '../../popups/menu-pagekey/menu-pagekey.component';

@Component({
  selector: 'app-page-key-access',
  templateUrl: './page-key-access.component.html',
  styleUrls: ['./page-key-access.component.scss']
})
export class PageKeyAccessComponent implements OnInit {
  FileUploadFor = FileUploadFor;
  lstSectionConfigKeys: string[] = ["table"];
  pageKeyAccessType: PageKeyAccessType = PageKeyAccessType.None;
  items: KeyValueSetInt[]; pageKey: number = 0; strPageKey = ''; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.PageKeyAndRoleAccess);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.pageKeyAccessType = routeParams.type;
      this.pageKey = routeParams.pageKey;
      this.strPageKey = PageKey[this.pageKey];
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.configurationManagementService.getPageKeysRoleAccess(this.pageKeyAccessType).subscribe(result => {
      this.items = result;
    });
  }

  onAction(index: number, key = null) {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(MenuPagekeyComponent);
        modalRef.componentInstance.pageKey = key;
      } break;
      case 2: {
        this.configurationManagementService.getAccessFile().subscribe(result => {
          this.localService.onDownloadFile(result, 'PageRoleAccessMapping');
        });
      } break;
    }
  }
}
